import { useState, useEffect } from "react";
import api from "../lib/api";

// Fetch a public collection; fall back to provided mock data if empty/error
export default function usePublicData(endpoint, fallback = []) {
  const [data, setData] = useState(fallback);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    api
      .get(endpoint)
      .then((res) => {
        if (!active) return;
        if (Array.isArray(res.data) && res.data.length > 0) setData(res.data);
        else setData(fallback);
      })
      .catch(() => active && setData(fallback))
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endpoint]);

  return { data, loading };
}
